import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "mdi has-text-grey-lighter mdi-clock mr-1" }, null, -1 /* HOISTED */)
const _hoisted_2 = { class: "mr-1 has-text-grey-lighter is-italic" }
const _hoisted_3 = { class: "has-text-grey-lighter is-italic" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "mdi mdi-download" }, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_button = _resolveComponent("n-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_n_date_picker = _resolveComponent("n-date-picker")!
  const _component_export_data_modal = _resolveComponent("export-data-modal")!
  const _component_page_header = _resolveComponent("page-header")!

  return (_openBlock(), _createBlock(_component_page_header, {
    brand: _ctx.avoltaConnectLogo,
    title: _ctx.$t('dashboard.title')
  }, {
    left: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.now.format('LLL')), 1 /* TEXT */),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.group?.config?.timezone || 'Europe/Paris'), 1 /* TEXT */)
    ]),
    actions: _withCtx(() => [
      (_ctx.group)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: { name: 'dispatch', params: { group: _ctx.group?.name }}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_n_button, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('dispatch.title')), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["to"]))
        : _createCommentVNode("v-if", true),
      (!!_ctx.since && !!_ctx.before)
        ? (_openBlock(), _createBlock(_component_n_date_picker, {
            key: 1,
            class: "mr-2 is-hidden-touch",
            value: _ctx.timerange,
            "onUpdate:value": [
              _cache[0] || (_cache[0] = ($event: any) => ((_ctx.timerange) = $event)),
              _ctx.setMonthRange
            ],
            type: "daterange",
            "month-format": "MMMM",
            shortcuts: _ctx.shortcuts,
            "is-date-disabled": _ctx.isRangeDateDisabled
          }, null, 8 /* PROPS */, ["value", "shortcuts", "is-date-disabled", "onUpdate:value"]))
        : _createCommentVNode("v-if", true),
      _createVNode(_component_n_button, {
        class: "mr-1",
        tertiary: "",
        round: "",
        size: "large",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.exportData()))
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_export_data_modal, {
        ref: "export",
        since: _ctx.since,
        before: _ctx.before,
        stations: _ctx.stations || []
      }, null, 8 /* PROPS */, ["since", "before", "stations"]),
      _createVNode(_component_n_button, {
        class: "mr-1",
        tertiary: "",
        round: "",
        size: "large",
        onClick: _ctx.refresh
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", {
            class: _normalizeClass([{spin: _ctx.isLoading}, "mdi mdi-refresh"])
          }, null, 2 /* CLASS */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["onClick"])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["brand", "title"]))
}